import { Box, HStack, Image, Text } from "@chakra-ui/react";
import React from "react";
import b2 from "../assets/b2.png";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <Box bgColor={"blackAlpha.900"} w={"full"} h={"85vh"}>
      <motion.div
        style={{
          height: "80vh",
        }}
        animate={{
          translateY: "20px",
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      >
        <HStack >
          <Image
            w={"full"}
            h={"full"}
            objectFit={"contain"}
            src={b2}
            filter={"grayscale(1)"}
          />

          <Text fontSize={"sm"} color={"whiteAlpha.600"} w={"80%"} letterSpacing={"wider"} alignItems={"center"} mr={"50px"}>
            We are your one-stop shop for all things cryptocurrency. Here,you will find detailed information on all the major cryptocurrencies,as well as up-to-date news and analysis.
            We also offer a variety of tools and resources to help you learn more about cryptocurrency and get started investing. Whether you are a beginner or an experienced investor, we have something for you. So come on in and explore! Here
            are some of the things you can find on our website: Detailed
            information on all the major cryptocurrencies: We provide
            comprehensive overviews of each cryptocurrency, including its
            history, technology, and current price. Up-to-date news and
            analysis: We keep you up-to-date on the latest news and analysis from the cryptocurrency world. A variety of tools and resources: We offer a variety of tools and resources to help you learn more about cryptocurrency and get started investing. 
            
            <Text fontWeight={"bold"}>We hope you enjoy using our website!</Text>
            
          </Text>
        </HStack>

        <Text
          fontSize={"6xl"}
          textAlign={"center"}
          fontWeight={"thin"}
          color={"whiteAlpha.900"}
          mt={"-5"}
        >
          CryotoX
        </Text>
      </motion.div>
    </Box>
  );
};

export default Home;
